function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5476 0H8.33319V7.5H13.5476V0Z",
  fill: "#2CD67D"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M13.5476 32.5H8.33319V40H13.5476V32.5Z",
  fill: "#2CD67D"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.33547 27.815C4.13443 28.7225 7.01276 29.6262 9.93672 29.6262C13.0862 29.6262 14.7483 28.3762 14.7483 26.435C14.7483 24.6675 13.3104 23.5887 9.66818 22.3825C4.6311 20.6562 1.30303 17.9825 1.30303 13.7125C1.30303 8.75372 5.66615 5.00122 12.7707 5.00122C16.2344 5.00122 18.7086 5.64872 20.5075 6.46747L18.9771 11.7287C17.8078 11.17 15.6034 10.35 12.6808 10.35C9.7125 10.35 8.27333 11.6862 8.27333 13.1525C8.27333 15.0062 9.93672 15.8262 13.8957 17.2925C19.247 19.19 21.7212 21.865 21.7212 26.0037C21.7212 30.875 17.8521 35.0162 9.53261 35.0162C6.07026 35.0162 2.65225 34.1112 0.943237 33.205L2.33547 27.815Z",
  fill: "#2CD67D"
});

var SvgDollarIcon = function SvgDollarIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 22,
    height: 40,
    viewBox: "0 0 22 40",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDollarIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dollar-icon.5fc2f5fc.svg";
export { ForwardRef as ReactComponent };